module.exports = __webpack_public_path__ + "static/media/logo-tianguis.daa84330.svg";